import axios from 'axios'
import * as https from 'https'
import { getSession, signOut } from 'next-auth/react'

export function setupAxios() {
	axios.defaults.httpsAgent = new https.Agent({
		rejectUnauthorized: false,
	})

	axios.defaults.validateStatus = () => true

	axios.interceptors.response.use(async (response) => {
		if (typeof window === 'undefined') return response


		if (response.status === 401) {
			await signOut({ callbackUrl: '/login' })
			return response
		}

		if (![401, 404, 403].includes(response.status)) return response

		const session = await getSession()

		if (!session || session.error) {
			await signOut({ callbackUrl: '/login' })
		}

		return response
	})

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (!error.response && typeof window !== 'undefined') {
				return error
			}

			if (error?.response?.status === 401 || error?.status === 401) {
				signOut({ callbackUrl: '/login' })
			}
			return error
		}
	)
}
